var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.item_class},[_c('router-link',{class:{
      'sidebar-menu__item-link': true,
      'inactive-item': _vm.current_open
    },attrs:{"to":_vm.item.route}},[(_vm.item.icon)?[_c(_vm.item.icon,{key:((_vm.item.name) + "-" + (_vm.item.route)),tag:"div",staticClass:"sidebar-menu__item-icon"})]:_vm._e(),_vm._v(" "+_vm._s(_vm.$t(_vm.item.title))+" ")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }